import { CommonModule } from '@angular/common';
import { Component, DestroyRef, OnInit, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterModule } from '@angular/router';

import { DataStateComponent } from '../../../shared/components/ui/data-state/data-state.component';
import { PageHeaderComponent } from '../../../shared/components/ui/page-header/page-header.component';
import { toErrorMessage } from '../../../shared/helpers/http-error';
import { PermissionsService } from '../../../shared/services/permissions.service';
import { ResourceDTO } from '../../../shared/types/permission.types';
import { PermissionsTabsComponent } from '../permissions-tabs/permissions-tabs.component';

interface ResourceRow extends ResourceDTO {
  _scopeNames: string[];
}

@Component({
  selector: 'app-resources-list',
  imports: [
    CommonModule,
    RouterModule,
    PermissionsTabsComponent,
    PageHeaderComponent,
    DataStateComponent,
  ],
  templateUrl: './resources-list.component.html',
})
export class ResourcesListComponent implements OnInit {
  private readonly permissionsService = inject(PermissionsService);
  private readonly destroyRef = inject(DestroyRef);

  readonly loading = signal(false);
  readonly error = signal<string | null>(null);
  readonly resources = signal<ResourceRow[]>([]);

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading.set(true);
    this.error.set(null);
    this.permissionsService
      .listResources()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res) => {
          this.resources.set(
            (res ?? []).map((r) => ({
              ...r,
              _scopeNames: (r.scopes ?? []).map((s) => s.name),
            })),
          );
          this.loading.set(false);
        },
        error: (err: unknown) => {
          this.loading.set(false);
          this.resources.set([]);
          this.error.set(toErrorMessage(err));
        },
      });
  }
}
